<script setup lang='ts' name='Help'>
import { ref, computed } from 'vue';
import { useFormStore } from '@/stores/form';
const formStore = useFormStore();

function gohome() {
  formStore.switchForm('login');
}

const helpContent = ref([
  {
    title: '如何登入帳號',
    content: `
      <p>請在首頁輸入您的帳號與密碼，然後點選 <strong>登入</strong> 按鈕。</p>
      <img src="/images/login-step.png" alt="登入步驟" />
      <p>如果無法登入，請確認密碼是否正確，或點選「忘記密碼」。</p>
    `
  },
  {
    title: '表單填寫教學',
    content: `
      <p>在進行申請時，請完整填寫以下欄位：</p>
      <ul>
        <li>姓名</li>
        <li>聯絡電話</li>
        <li>電子郵件</li>
      </ul>
      <img src="/images/form-guide.png" alt="表單範例" />
      <p>標有紅色星號的欄位為必填。</p>
    `
  }
]);

// 目前選擇的文章索引
const selectedIndex = ref(0);

</script>

<template>
    <div class="help">
      <h2>幫助詳細說明</h2>
      <hr>
      <!-- 下拉選單 -->
      <select v-model="selectedIndex">
        <option v-for="(item, index) in helpContent" :value="index" :key="index">
          {{ item.title }}
        </option>
      </select>
  
      <!-- 顯示所選內容 -->
      <div v-html="helpContent[selectedIndex].content" class="article-content"></div>
  
      <button @click="gohome">返回</button>
    </div>
  </template>
  



<style scoped>
.help {
  padding: 20px;
}

input {
  padding: 8px;
  margin-bottom: 12px;
  width: 400px;
  box-sizing: border-box;
}

ul {
  padding-left: 20px;
}

button {
  margin-top: 20px;
}


select {
  padding: 8px;
  margin: 12px 0;
  width: 400px;
  box-sizing: border-box;
}

.article-content img {
  max-width: 100%;
  margin-top: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
</style>
